/* eslint-disable @typescript-eslint/no-explicit-any */
import { SetStateAction, useCallback, useRef } from 'react';
import { useState } from 'react';

/**
 * Permite manejar un estado que se actualizará únicamente siguiendo el
 * comportamiento esperado de un debounce
 */
export function useDebouncedState<T>(
  timeout: number,
  initialState?: T,
): [T | undefined, (state: SetStateAction<T>, immediate?: boolean) => unknown] {
  const [state, innerSetState] = useState<T>(initialState as T);

  const t = useRef<number>(-1);

  const setState = useCallback<
    (state: SetStateAction<T>, immediate?: boolean) => unknown
  >(
    (newState, immediate?: boolean) => {
      clearTimeout(t.current);

      if (immediate) innerSetState(newState);
      else
        t.current = setTimeout(() => {
          innerSetState(newState);
        }, timeout) as any;
    },
    [timeout],
  );

  return [state, setState];
}
